import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayersTwo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayersTwo"><Path d="M8 12.1118L2.5 15.1875L12 20.5L21.5 15.1875L16 12.1118M12 3.5L2.5 8.8125L8.2 12L12 14.125L15.8 12L21.5 8.8125L12 3.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconLayersTwo;
